export default __webpack_public_path__ + "static/media/logo-full-dark.98ebcefe.svg";